<template>
    <div style="width: 95px;">
        <el-popover
            placement="bottom"
            width="430"
            popper-class="mypopper"
            @show="showBeveragePicLib"
            trigger="click"
            >
            <el-row :gutter="20">
                <el-col :span="6" style="padding-left: 5px;padding-right: 5px;">
                    <el-upload
                        class="avatar-uploader"
                        :action ="uploadurl"
                        :data="uploadParamBeverage"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload"
                        :headers="uploadHeaders"
                        >
                        <i class="el-icon-plus avatar-uploader-icon" style="width: 100px!important;height: 100px!important;"></i>
                    </el-upload>
                </el-col>
                <el-col v-for="(item,index) in beveragePics" :key="index" :span="6" style="height:100px;vertical-align:top;position：relative;padding-left: 5px;padding-right: 5px;margin-bottom:5px">
                    <!-- <i class="el-icon-error" style="position:absolute;z-index:999999" @click="closeDeletePic(item,index)"></i> -->
                    <el-image class="img" @click="chooseBeverageImg(item)" :src="item.path"></el-image>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" style="margin-top:2%;text-align:center">
                    <el-pagination
                        small
                        layout="prev, pager, next"
                        :page-size="11"
                        @current-change="handleCurrentChangePic"
                        :total="beveragePicsCount"
                        :current-page="currentPage">
                    </el-pagination>
                </el-col>
            </el-row>
            <a slot="reference"><el-image class="imgaa" :src="plussrc" ></el-image></a>
        </el-popover>
    </div>
</template>

<script >
export default {
    props:{
        filecatalog:null
    },
    data(){
        return {
            uploadHeaders:{authorization:"bearer "+this.$account.data.token},
            //uploadurl: "https://icloud.lhcoffeetime.com/api/File/Upload",
            uploadurl: this.$httpservice.host+"api/File/Upload",
            uploadParamBeverage:{filecatalog:this.filecatalog},
            beveragePics:[],
            formLabelWidth:'120',
            plussrc: require('@/assets/images/plus.png'),
            userTreeloading:true,
            beveragePicsCount:0,
            currentPage:1
        }
    },

    methods:{
        chooseBeverageImg(item){
            this.$emit('choose-img', item);
        },
        showBeveragePicLib(){
            this.beveragePics = [];
            this.currentPage=1;
            this.loadFilLib(1);
        },
        //加载图片库列表
        loadFilLib(pageIndex){
            this.currentPage=pageIndex;
            this.beveragePics = [];
            let that = this;
            let param = {
                pageIndex:pageIndex,
                pageSize:11,
                order:"createdOn",
                sequence:false,
                filecatalog:this.filecatalog
            }
            this.$httpservice.get("api/file/list",param).then(
                function (data) {
                    if(data.body.code=="200"){
                        data.body.data.forEach(element => {
                            that.beveragePics.push(element);
                        });

                        that.beveragePicsCount = data.body.totalCount;
                    }else{
                        that.$message({
                            message: data.body.msg,
                            type: 'warning'
                        });
                    }
                },
                function (data) {
                    that.userTreeloading= false;
                    let statusCode = data.status;
                    that.$message({
                        message: that.$t('queryFailedStatusCode')+statusCode,
                        type: 'warning'
                    });
                }
            );
        },
        handleCurrentChangePic(e){

          this.loadFilLib(e);
        },
        handleAvatarSuccess(res, file) {
            this.beveragePics = [];
            this.loadFilLib(1);
        },
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
            this.$message.error(this.$t('equipmentmanagement.theSizeOfTheUploadedImageCannotMoreThan2MB'));
            }
            return isLt2M;
        },
        closeDeletePic(e){
            let that = this;
            this.$httpservice.post("api/File/Delete",[e.id]).then(
                function (data) {
                    if(data.body.code=="200"){
                        that.$message({
                                message: that.$t('equipmentmanagement.deleteImageSuccessfully'),
                                type: 'success'
                        });
                        that.loadFilLib(1)
                    }else{
                        that.$message({
                            message: data.body.msg,
                            type: 'danger'
                        });
                    }
                },
                function (data) {
                    let statusCode = data.status;
                    that.$message({
                        message: that.$t('queryFailedStatusCode')+statusCode,
                        type: 'warning'
                    });
                }
            );
        }
    }
}
</script>

<style scoped>

.dialog_item{
  display: flex;

}
.dialog_item_element{
  flex: 3;
}
.dialog_item_label{
  width: 100px;
  text-align: right;
  padding-right: 10px;
}
.imgaa{
    border: 1px dotted #ddd;

}
.imgaa:hover{
    border: 1px dotted rgb(54, 110, 194);
}
</style>



// WEBPACK FOOTER //
// src/components/PictureLibrary.vue